import Vue from 'vue';
import { install } from 'ga-gtag';
import sendMetrics from '@/utils/webVitals';
import 'slick-carousel/slick/slick.css';
import User from './views/user.vue';
import Store from './store/store_user.js';
import Router from './router/user_router.js';
import './plugins/axios';

install(process.env.VUE_APP_USER_GTAG_ID);
Vue.config.productionTip = false;
sendMetrics();

new Vue({
  router: Router,
  store: Store,
  render: h => h(User)
}).$mount('#app');
